import React from 'react';
import styled, { css } from 'styled-components';

const BodyOuter: React.FCC = ({ children }) => (
  <Container>{children}</Container>
);

const Container = styled.div<{}>(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.color('white')};
    border-top: 1px solid ${theme.color('tertiary')};
    border-bottom-left-radius: ${theme.getTokens().border.radius.m};
    border-bottom-right-radius: ${theme.getTokens().border.radius.m};
  `,
);

export default BodyOuter;
